const getMustChangeFields = (type: string) => {
  if (type === 'main') return []
  return ['title', 'longTitle', 'description']
}

export default getMustChangeFields
